import { Group, Text } from "@mantine/core";
import { ReactNode } from "react";
import { SpecialistDataProps } from "../../../hooks/react-query/useSpecialist";
import { uuidv4 } from "@firebase/util";
import Image from "next/image";

export function Languages(props: SpecialistDataProps) {
  const languageData = [
    {
      label: "English",
      value: "GB",
      image:
        "https://firebasestorage.googleapis.com/v0/b/psi-works-backoffice.appspot.com/o/flags%2Fgb.svg?alt=media&token=31e17efc-1e16-480f-9297-77cba1df779d&_gl=1*14q9gfq*_ga*NTI3MDg2NTUzLjE2ODI1MjkzNjI.*_ga_CW55HF8NVT*MTY4NTQzNzQwMS4zLjEuMTY4NTQzNzYwNi4wLjAuMA..",
    },
    {
      label: "Português",
      value: "PT",
      image:
        "https://firebasestorage.googleapis.com/v0/b/psi-works-backoffice.appspot.com/o/flags%2Fpt.svg?alt=media&token=ac8f6ec8-0142-44f5-8865-77340341fccb&_gl=1*1dcm576*_ga*NTI3MDg2NTUzLjE2ODI1MjkzNjI.*_ga_CW55HF8NVT*MTY4NTQzNzQwMS4zLjEuMTY4NTQzNzYzNi4wLjAuMA..",
    },
    {
      label: "Castellano",
      value: "ES",
      image:
        "https://firebasestorage.googleapis.com/v0/b/psi-works-backoffice.appspot.com/o/flags%2Fes.svg?alt=media&token=8c315ee8-56e1-4a45-ac7f-6961d13914bf&_gl=1*e5h6v4*_ga*NTI3MDg2NTUzLjE2ODI1MjkzNjI.*_ga_CW55HF8NVT*MTY4NTQzNzQwMS4zLjEuMTY4NTQzNzUxNi4wLjAuMA..",
    },
    {
      label: "Deutsch",
      value: "DE",
      image:
        "https://firebasestorage.googleapis.com/v0/b/psi-works-backoffice.appspot.com/o/flags%2Fde.svg?alt=media&token=450899d7-779e-4185-a84e-6b6d55a7c2f2&_gl=1*5kbkyu*_ga*NTI3MDg2NTUzLjE2ODI1MjkzNjI.*_ga_CW55HF8NVT*MTY4NTQzNzQwMS4zLjEuMTY4NTQzNzY1OC4wLjAuMA..",
    },
    {
      label: "Français",
      value: "FR",
      image:
        "https://firebasestorage.googleapis.com/v0/b/psi-works-backoffice.appspot.com/o/flags%2Ffr.svg?alt=media&token=145757da-d34c-4754-b37f-7a3668fa1cb1&_gl=1*1ukzb9e*_ga*NTI3MDg2NTUzLjE2ODI1MjkzNjI.*_ga_CW55HF8NVT*MTY4NTQzNzQwMS4zLjEuMTY4NTQzNzY3NC4wLjAuMA..",
    },
  ];

  function selectLanguage(value: string): ReactNode {
    const option = languageData.filter((option) => option.value === value)[0];

    return (
      <Group wrap={"nowrap"}>
        <Image src={option.image} width={40} height={30} alt="language" />
        <div>
          <Text>{option.label}</Text>
        </div>
      </Group>
    );
  }

  return (
    <div className="w-full flex justify-center items-center">
      <ul className="w-[220px] m-0">
        {props.specialist.languages.map((lang) => {
          return (
            <li
              className="my-4"
              style={{ listStyleType: "none" }}
              key={uuidv4()}
            >
              {selectLanguage(lang)}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
